import { useState } from "react";
import { useDispatch } from "react-redux";
import I18n from "common/i18n";
import Constants from "common/constant";
import { btnDelay, usePlaySound } from "common/utils";
import { actions } from "features/course/slice";

export const PieceBuilderStartPage = () => {
  const play = usePlaySound();
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);

  const handleStart = () => {
    play();
    dispatch(actions.updateShowCourseList(true));
    btnDelay(() => setStart(false));
  };

  const handleAnimationEnd = () => {
    dispatch(actions.updateShowCourseTop(false));
    setStart(true);
  };

  return (
    <div
      className={`flex-col-el flex-center z-[100] w-full h-full bg-gray2-100 absolute will-change-transform ${
        start ? "" : "animate__animated animate__bounceOutUp pointer-events-none"
      }`}
      onAnimationEnd={handleAnimationEnd}
    >
      <div className="flex-col-el flex-center relative w-full h-full">
        <img
          alt="ピースビルダー スタート画面"
          src={`${Constants.assetHost}/assets/images/course_builder_start.webp`}
          className="w-full h-full border-solid border border-textcolor-black"
        />

        <div className="flex-col-el flex-center absolute bottom-12 rho z-50">
          <button className="btn btn-secondary type-inherit-font" onClick={handleStart}>
            <p className="text-body text-white type-hero">{I18n.t("MSG_COURSE_START_BTN")}</p>
          </button>
        </div>
      </div>
    </div>
  );
};
